import * as _ from "lodash";
import {IConsumptionAdjustmentsFactory, IConsumptionAdjustmentsFactoryOptions} from "./PA.Consumption.IF";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {WB_ConsumptionProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import {ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {esWB_Consumption_Product, esWB_Consumption_Product_Group} from "../PA.Core/PAdbSchema";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {BehaviorSubject} from "../../node_modules/rxjs/BehaviorSubject";
import {ConsumptionAdjustmentsCalculator} from "../PA.Consumption.Services/ConsumptionAdjustmentCalculator";
import {
  IConsumptionAdjustmentsCalculator,
  IHaveConsumptionAdjustmentsCalculator
} from "../PA.Consumption.Services/PA.Consumption.Services.IF";

// TODO:
//  Track
//    Attach Calculator Unit Calculator
//    Create Sync Metric Calculate Queue
//    Async Lock


export class ConsumptionAdjustmentsFactory
  implements
    IConsumptionAdjustmentsFactory,
    IHaveConsumptionAdjustmentsCalculator
{
  static dbContext: PAdbContext = undefined
  static dctConsumptionPGs: {[id: number]: WB_ConsumptionProductGroupRow} = {}
  static _OnLoaded: BehaviorSubject<WB_ConsumptionProductGroupRow[]> = new BehaviorSubject<WB_ConsumptionProductGroupRow[]>([])
  static _ConsumptionAdjustmentsCalculator: ConsumptionAdjustmentsCalculator = undefined

  constructor(){
    if(!ConsumptionAdjustmentsFactory.dbContext){
      ConsumptionAdjustmentsFactory.dbContext = new PAdbContext()
      ConsumptionAdjustmentsFactory._ConsumptionAdjustmentsCalculator = new ConsumptionAdjustmentsCalculator()
      ConsumptionAdjustmentsFactory._ConsumptionAdjustmentsCalculator.Register(this)
    }
  }

  // Relay to Static Methods
  Load(arrWB_Cust_ID_PlanningCustomer: number[],
       arrWB_Cust_ID_SourceCustomers: number[],
       arrWB_PrdGrp_ID: number[],
       StartDt: Date,
       EndDt: Date): Promise<WB_ConsumptionProductGroupRow[]> {
    return ConsumptionAdjustmentsFactory.singularLoad(arrWB_Cust_ID_PlanningCustomer, arrWB_Cust_ID_SourceCustomers, arrWB_PrdGrp_ID, StartDt, EndDt)
  }

  get OnLoaded(): BehaviorSubject<WB_ConsumptionProductGroupRow[]>{
    return ConsumptionAdjustmentsFactory._OnLoaded
  }

  Find(arrWB_Cust_ID_PlanningCustomer: number[],
       arrWB_Cust_ID_SourceCustomers: number[],
       arrWB_PrdGrp_ID: number[],
       StartDt: Date,
       EndDt: Date): WB_ConsumptionProductGroupRow[] {

    return ConsumptionAdjustmentsFactory.singularFind(arrWB_Cust_ID_PlanningCustomer, arrWB_Cust_ID_SourceCustomers, arrWB_PrdGrp_ID, StartDt, EndDt);

  }


  Save(arrWB_Cust_ID_Planning: number[],
       arrWB_PrdGrp_ID: number[],
       options?: IConsumptionAdjustmentsFactoryOptions): Promise<void> {
    return ConsumptionAdjustmentsFactory.singularSave(arrWB_Cust_ID_Planning, arrWB_PrdGrp_ID, options)
  }

  get AdjustmentsCalculator(): IConsumptionAdjustmentsCalculator {
    return ConsumptionAdjustmentsFactory._ConsumptionAdjustmentsCalculator
  }




  static singularLoad(arrWB_Cust_ID_PlanningCustomer: number[],
                     arrWB_Cust_ID_SourceCustomers: number[],
                     arrWB_PrdGrp_ID: number[],
                     StartDt: Date,
                     EndDt: Date): Promise<WB_ConsumptionProductGroupRow[]> {

    return new Promise<WB_ConsumptionProductGroupRow[]>((resolve, error) => {

      // Use Record Resolver..
      let aRecordResolver = new ESRecordResolver(ConsumptionAdjustmentsFactory.dbContext,
        {dctExcludeHasManyNamedRelations: {[esWB_Consumption_Product_Group]: [esWB_Consumption_Product] }})

      // Setup Query
      let findQuery: any = {WB_CUST_ID_PLANNING: {in: arrWB_Cust_ID_PlanningCustomer},
                            WB_PRDGRP_ID:        {in: arrWB_PrdGrp_ID} }
      if (!_.isEmpty(arrWB_Cust_ID_SourceCustomers)){
        findQuery.WB_CUST_ID_SOURCE = {in: arrWB_Cust_ID_SourceCustomers }
      }
      findQuery.END_DT = {'>=': DateUtils.convertToSAPBW(StartDt) }
      findQuery.START_DT = {'<=': DateUtils.convertToSAPBW(EndDt) }


      aRecordResolver.queryAllWithRelationships(esWB_Consumption_Product_Group, {where: findQuery})
        .then((results: WB_ConsumptionProductGroupRow[]) => {
          ConsumptionAdjustmentsFactory._OnLoaded.next(results)
          resolve(results)
        }).catch((err) => {
          error(err)
        })

    })

  }

  static singularFind(arrWB_Cust_ID_PlanningCustomer: number[],
                      arrWB_Cust_ID_SourceCustomers: number[],
                      arrWB_PrdGrp_ID: number[],
                      StartDt: Date,
                      EndDt: Date): WB_ConsumptionProductGroupRow[] {

    // Setup Query
    let findQuery: any = {}

    if (!_.isEmpty(arrWB_Cust_ID_PlanningCustomer)) {
      findQuery.WB_CUST_ID_PLANNING = {in: arrWB_Cust_ID_PlanningCustomer}
    }

    if (!_.isEmpty(arrWB_PrdGrp_ID)) {
      findQuery.WB_PRDGRP_ID = {in: arrWB_PrdGrp_ID}
    }

    if (!_.isEmpty(arrWB_Cust_ID_SourceCustomers)) {
      findQuery.WB_CUST_ID_SOURCE = {in: arrWB_Cust_ID_SourceCustomers}
    }

    if(_.isDate(StartDt)) {
      findQuery.END_DT = {'>=': DateUtils.convertToSAPBW(StartDt)}
    }

    if(_.isDate(EndDt)) {
      findQuery.START_DT = {'<=': DateUtils.convertToSAPBW(EndDt)}
    }

    return ConsumptionAdjustmentsFactory.dbContext.filter(esWB_Consumption_Product_Group,findQuery)

  }

  static singularSave(arrWB_Cust_ID_Planning: number[],
                      arrWB_PrdGrp_ID: number[],
                      options?: IConsumptionAdjustmentsFactoryOptions): Promise<void> {

    return new Promise<void>((resolve, error) => {

      let rowsToSave = ConsumptionAdjustmentsFactory.dbContext.filter(esWB_Consumption_Product_Group,
        {where: {
                 WB_CUST_ID_PLANNING: {in: arrWB_Cust_ID_Planning},
                 WB_PRDGRP_ID: {in: arrWB_PrdGrp_ID }
          }})


      ConsumptionAdjustmentsFactory.dbContext.Save(esWB_Consumption_Product_Group, rowsToSave)
        .then((ignore) => {
          resolve()
        }).catch((err) => {
          error(err)
        })

    })
  }





}